import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}
const CHECKOUT_URL = 'https://vitalizateahora.com/cart/52045530595559:1';
export function CTAButton({
  className = '',
  onClick,
  children
}: CTAButtonProps) {
  if (onClick) {
    return <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={onClick} className={`group relative inline-flex items-center justify-center gap-3 bg-accent-600 hover:bg-accent-700 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-[0_8px_20px_rgba(234,88,12,0.3)] transition-colors w-full sm:w-auto overflow-hidden ${className}`} data-id="element-1">
        <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-full" data-id="element-2" />
        <span className="relative z-10 flex items-center gap-2" data-id="element-3">
          {children || '¡QUIERO CAMINAR SIN DOLOR! DESCARGAR AHORA'}
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-4" />
        </span>
      </motion.button>;
  }
  return <motion.a whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} href={CHECKOUT_URL} target="_top" rel="noopener noreferrer" onClick={e => {
    // Defensive fallback: ensure navigation happens even if target is blocked
    try {
      if (window.top) {
        window.top.location.href = CHECKOUT_URL;
      } else {
        window.location.href = CHECKOUT_URL;
      }
    } catch {
      window.location.href = CHECKOUT_URL;
    }
  }} className={`group relative inline-flex items-center justify-center gap-3 bg-accent-600 hover:bg-accent-700 text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-[0_8px_20px_rgba(234,88,12,0.3)] transition-colors w-full sm:w-auto overflow-hidden no-underline ${className}`} data-id="element-5">
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-full" data-id="element-6" />
      <span className="relative z-10 flex items-center gap-2" data-id="element-7">
        {children || '¡QUIERO CAMINAR SIN DOLOR! DESCARGAR AHORA'}
        <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-8" />
      </span>
    </motion.a>;
}